import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import PageSection from '../../../PageSection'
import BarGraph from '../../../Graphs/BarGraph'

import { formatNumber } from '../../../../../helpers/numbers'
import { formatSegmentLabels } from '../../helpers'

import useStyles from '../../styles'

const LeadGraphSection = ({ rawGraphData }) => {
  const classes = useStyles()

  const leadGraphData = useMemo(
    () => rawGraphData && rawGraphData.data && rawGraphData.data.map(data => data.value),
    [rawGraphData]
  )
  const leadGraphLabels = useMemo(() => formatSegmentLabels(rawGraphData), [rawGraphData])

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>Leads</div>
        <div className={classes.value}>{formatNumber(rawGraphData.total)}</div>
      </div>
      <BarGraph className={classes.graphWrapper} data={leadGraphData} labels={leadGraphLabels} format="integer" />
    </PageSection>
  )
}

LeadGraphSection.propTypes = {
  rawGraphData: PropTypes.object.isRequired
}

export default LeadGraphSection
